import React from "react";
import styled from "styled-components";
import theme from "../utils/theme";
import MainSection from "./common/MainSection";
// import { Link } from "react-router-dom";
const cdn_url = process.env.REACT_APP_CDN_API_SERVER_URL;
const CsHelpImage = `${cdn_url}/assets/version-2/main/main-cs-help.svg`;

/**
 * @brief v.2.0 메인페이지 CS배너
 */
export default function HomeCsBanner({ scrollToForm }) {
  return (
    <MainSection>
      <CsHelpBox>
        <CsHelpText>
          <div>
            <span>사용이 어려우신가요?</span>
            <h2>
              이든든 상담사가
              <br />
              <strong>도와드릴게요!</strong>
            </h2>
          </div>
          <CsHelpButton onClick={scrollToForm}>네, 도와주세요!</CsHelpButton>
        </CsHelpText>
        <img src={CsHelpImage} alt="cs-man" />
      </CsHelpBox>
    </MainSection>
  );
}

const NavyBanner = styled.div`
  width: 78%;
  max-width: 430px;
  margin: 0 0 20px 0;
  height: 500px;
  border-radius: 24px;
  background-color: ${theme.subDarkColor};
  padding: 40px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  img {
    position: absolute;
    right: 0px;
    bottom: 0;
    width: 90%;
    height: auto;
  }
`;

const NavyBannerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  justify-content: center;
  padding: 0;
  h2 {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    margin: 0;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    margin: 0;
  }
`;

const CsHelpBox = styled(NavyBanner)`
  max-width: 430px;
  width: 78%;
  margin: 0 auto;
  height: 400px;
  min-height: 400px;
  padding: 40px 40px 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  img {
    position: relative;
    align-self: center;
  }
`;

const CsHelpText = styled(NavyBannerText)`
  height: auto;
  justify-content: flex-start;
  padding: 0;
  align-self: flex-start;
  div {
    display: flex;
    flex-direction: column;
  }
  h2 {
    margin-top: 8px;
    font-size: 24px;
  }
  span {
    font-size: 16px;
    font-weight: 300;
  }
`;

const CsHelpButton = styled.button`
  color: ${theme.navyColor};
  background-color: ${theme.mainColor};
  border-radius: 8px;
  width: 132px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  margin-top: 16px;
`;